// import App from './App'
// import About from './components/marketing/About'
import Login from './components/auth/Login.vue'
import Logout from './components/auth/Logout.vue'
// import Register from './components/auth/Register.vue'
import OrderList from './components/orderlist/OrderList.vue'
import priceEdit from './components/prices/priceList.vue'
import printTerminal from './components/printTerminal/printTerminal.vue'
import materials from './components/materials/materials.vue'
import contragents from './components/contragents/contragents.vue'
import charges from './components/bank/chargeList.vue'
// import users from './components/users/users.vue'
import executors from './components/executors/executors.vue'
import tuning from './components/tuning/tuning.vue'
import reports from './components/reports/reports.vue'

const routes = [

    { 
        path:'/reports', 
        name : 'reports',
        component: reports,
        meta : {
            requiresAuth : true,
            permission : 'manager-terminal',
        }
    },

    
    { 
        path:'/tuning', 
        name : 'tuning',
        component: tuning,
        meta : {
            requiresAuth : true,
            permission : '*',
        }
    },

    { 
        path:'/executers', 
        name : 'executers',
        component: executors,
        meta : {
            requiresAuth : true,
            permission : '*',
        }
    },

    { 
        path:'/contragents', 
        name : 'contragents',
        component: contragents,
        meta : {
            requiresAuth : true,
            permission : 'manager-terminal',
        }
    },

    { 
        path:'/', 
        name : 'orders',
        component: OrderList,
        meta : {
            requiresAuth : true,
            permission : 'manager-terminal',
        }
    },
    
    { 
        path:'/login',
        name : 'login', 
        component: Login,
        meta : {
            requiresVisitor : true,
        }
    },
    // { 
    //     path:'/register',
    //     name : 'register', 
    //     component: Register 
    // },

    { 
        path:'/logout',
        name : 'logout', 
        component: Logout,
        meta : {
            requiresAuth : true,
            permission : '',
        }
    },

    { 
        path:'/orders',
        name : 'orders', 
        component: OrderList,
        meta : {
            requiresAuth : true,
            permission : 'manager-terminal',
        }
    },

    {
        path : '/prices',
        name : 'prices',
        component : priceEdit,
        meta : {
            requiresAuth : true,
            permission : '*',
        }        
    },

    {
        path : '/printTerminal',
        name : 'printTerminal',
        component : printTerminal,
        meta : {
            requiresAuth : true,
            permission : 'print-terminal',
        }        
    },

    {
        path : '/materials',
        name : 'materials',
        component : materials,
        meta : {
            requiresAuth : true,
            permission : '*',
        }        
    },

    {
        path : '/charges',
        name : 'charges',
        component : charges,
        meta : {
            requiresAuth : true,
            permission : 'add-beznal',
        }        
    },

    // {
    //     path : '/users',
    //     name : 'users',
    //     component : users,
    //     meta : {
    //         requiresAuth : true,
    //         permission : '*',
    //     }        
    // },



];

export default routes;